import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from '../ui/button';
import { COMPANY_INFO } from '../../data/mock';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Services', path: '/services' },
    { name: 'Pricing', path: '/pricing' },
    { name: 'Subscriptions', path: '/subscriptions' },
    { name: 'Service Area', path: '/service-area' },
    { name: 'FAQs', path: '/faqs' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header-sticky">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src={COMPANY_INFO.logoUrl} 
              alt="Transa" 
              className="h-10 md:h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                  isActive(link.path)
                    ? 'text-[#0D9488] bg-[#F0FDFA]'
                    : 'text-[#475569] hover:text-[#111111] hover:bg-[#F8FAFC]'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-3">
            <Link to="/subscribe">
              <Button variant="outline" className="border-[#7C3AED] text-[#7C3AED] hover:bg-[#7C3AED] hover:text-white">
                Subscribe
              </Button>
            </Link>
            <Link to="/book/waste">
              <Button className="bg-[#0D9488] hover:bg-[#0F766E] text-white">
                Collect My Packaging
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-lg hover:bg-[#F8FAFC]"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6 text-[#111111]" />
            ) : (
              <Menu className="w-6 h-6 text-[#111111]" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-[#E2E8F0] animate-fade-in">
            <nav className="flex flex-col space-y-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`px-4 py-3 text-sm font-medium rounded-lg ${
                    isActive(link.path)
                      ? 'text-[#0D9488] bg-[#F0FDFA]'
                      : 'text-[#475569] hover:text-[#111111] hover:bg-[#F8FAFC]'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <div className="pt-4 space-y-2">
                <Link to="/subscribe" onClick={() => setMobileMenuOpen(false)}>
                  <Button variant="outline" className="w-full border-[#7C3AED] text-[#7C3AED]">
                    Subscribe
                  </Button>
                </Link>
                <Link to="/book/waste" onClick={() => setMobileMenuOpen(false)}>
                  <Button className="w-full bg-[#0D9488] hover:bg-[#0F766E] text-white">
                    Collect My Packaging
                  </Button>
                </Link>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
